import React from 'react'

interface BlurredWrapperProps {
  blur?: boolean
  onClickHijack?: (event: React.MouseEvent) => void
}

// Wrap a component with a blur filter
const BlurredWrapper: React.FC<React.PropsWithChildren<BlurredWrapperProps>> = (
  props,
) => {
  const { blur = true, onClickHijack, children } = props
  return (
    <div
      style={{ filter: blur ? 'blur(5px)' : 'none' }}
      onClickCapture={(event: React.MouseEvent) => {
        event.stopPropagation()
        onClickHijack?.(event)
      }}
    >
      {children}
    </div>
  )
}

export default BlurredWrapper
